import styled from 'styled-components';

export const NavigationRowsStyled = styled.div`
  display: flex;
  flex-direction: column;

  .form-field-container {
    margin-bottom: 12px;
  }

  .control-label {
    color: #3a3a52;
    font-weight: 400;
  }

  [class^='col-'],
  [class*=' col-'] {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const NavigationRowStyled = styled.div`
  display: flex;
  flex-direction: column;

  & + & {
    border-top: 1px solid #e5e7eb;
    margin-top: 12px;
    padding-top: 20px;
  }

  .control-label .tooltip-container {
    margin-left: 8px;
  }
`;

export const NavigationRowActionsStyled = styled.div`
  display: flex;

  button {
    display: flex;
    gap: 6px;
  }
`;

export const NavigationFooterStyled = styled.div`
  border-top: 1px solid #e5e7eb;
  display: flex;
  margin-top: 12px;
  padding-top: 20px;
`;

export const PageNavigationRowStyled = styled.div`
  align-items: center;
  display: flex;

  & > .tooltip-container {
    margin-left: auto;
  }

  button {
    padding-left: 0;
    text-decoration: underline;
  }
`;
